export default __webpack_public_path__ + "static/media/labelmaps.cb83b2c8.png";